// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import DirectoryVin from './DirectoryVin';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(DirectoryVin);
